<template>
    <div>
        <nsw-menu
            :isShowDesktopMenu="false"
        ></nsw-menu>
        <div class="content-wrapper general">
            <h3 class="title-head">{{ lang($t("Terms and Conditions")) }}</h3>
            <div class="content-box">

                <div class="terms-para">
                    <p v-html="lang($t('%current_website% website (the %current_website%). The %current_website% website is governed by the following Terms of Use (\'Terms\') to ensure that it is legally and properly used. If you continue to browse and use this website, you (\'users\') agree to comply with and be bound by the following Terms.'), { current_website: current_website })"></p>
                    <!--<p>歡迎來訪 <a class="txt-link" :href="current_website">{{ current_website }}</a>！本網站的宗旨是提供廣泛的書籍及其他傳媒產品給公眾選擇。為了保障此網站能夠被合法及適當使用，本網站訂立以下使用條款。任何人士瀏覽此網站"用家"（Users）都同意遵守此條款。</p>-->
                </div>

                <h4 class="terms-title">{{ lang($t("Definitions")) }}</h4>
                <div class="terms-para">
                    <p>{{ lang($t("DefinitionsH1")) }}</p>
                    <ul>
                        <li><p v-html="lang($t('\'Contents\' refers to all contents on %current_website% website, including information, data, text, graphs, fonts, images, photos, stores, button icons, sound, music, video and software;'), { current_website: current_website })"></p></li>
                        <li><p v-html="lang($t('\'Intellectual Property\' refers to intellectual property of all forms of contents, including copyrights, registered designs, trademarks and invention patents;'), { current_website: current_website })"></p></li>
                        <li><p v-html="lang($t('\'Linked website\' refers to websites linked with the %current_website% website (including but not limited to hypertext links, contents links and frame links);'), { current_website: current_website })"></p></li>
                        <li><p v-html="lang($t('\'%current_website% website\' refers to \'%current_website%\' but not including linked websites;'), { current_website: current_website })"></p></li>
                        <li><p v-html="lang($t('\'Providers\' refers to individuals providing contents;'), { current_website: current_website })"></p></li>
                        <li><p v-html="lang($t('and \'Users\' refers to individuals browsing the %current_website% website for any purposes.'), { current_website: current_website })"></p></li>
                    </ul>
                </div>

                <h4 class="terms-title">{{ lang($t("Disclaimer")) }}</h4>
                <div class="terms-para">
                    <p v-html="lang($t('%current_website% website. The %current_website% website is provided on an \'as is\' basis by %current_website%. %current_website% makes no representations or warranties of any kind, express or implied, as to the operation or the contents of %current_website% website. To the fullest extent permitted by the relevant laws of the Hong Kong SAR, China, %current_website% makes no representations or warranties of any kind, express or implied, as to including but not limited to quality or fitness for any particular purpose of goods. In no event shall %current_website% be liable for any incidental, indirect, exemplary, punitive and consequential damages resulting from the use of the %current_website% website.'), {current_website: current_website})"></p>
                </div>

                <h4 class="terms-title">{{ lang($t("Third-party contents")) }}</h4>
                <div class="terms-para">
                    <p v-html="lang($t('%current_website% does not have the right to edit such contents. The third-party providers or users, while providing contents including comments, recommendations, statements, services, suggestions and other information, are responsible and liable for such contents. The executives, directors and staffs of %current_website% take no responsibilities and assume no liabilities for any contents provided by any third-party providers and users.'), {current_website: current_website})"></p>
                </div>

                <h4 class="terms-title">{{ lang($t("Conduct of Internet User")) }}</h4>
                <div class="terms-para">
                    <p v-html="lang($t('%current_website% website for purposes that are legal. Users are strictly prohibited to show or transmit any contents that are illegal, detrimental, threatening, abusive, harassing, scandalous, nasty, obscene, sexually explicit, discriminating and offensive on %current_website% website, which includes but not limited to inciting any criminal acts, and any acts which lead to civil liabilities or violate laws of any regions, states, countries or any international laws. If %current_website% receives any complaints on user provided contents which are against intellectual property, scandalous, detrimental, illegal or abusive, after investigation, %current_website% in its sole discretion would decide whether removing such contents or requesting users to remove them. %current_website% reserve the rights to disclose any contents or other electronic communication: (i) to satisfy legal, ordinance or Government\'s requirements (ii) if such disclosure is essential or appropriate for the operation of %current_website% (iii) to protect the rights and properties of the users and providers of %current_website%. %current_website% reserves the right to ban any actions, information or contents that are regarded as illegal or detrimental to %current_website% users, %current_website% communities and the rights of %current_website% and third parties. Although %current_website% reserves such rights, it does not guarantee immediate removal of questionable contents. %current_website%, its related personnel, executives, directors, staffs and agents take no responsibilities or liabilities on whether or not to take actions about the behaviors, information transmissions or contents by providers (except %current_website%) and users.'), {current_website: current_website})"></p>
                </div>

                <h4 class="terms-title">{{ lang($t("Termination")) }}</h4>
                <div class="terms-para">
                    <p v-html="lang($t('%current_website% that the actions of users has violated any laws and are detrimental to other users, third-party providers or %current_website%, %current_website% reserve the rights to terminate or suspend users\' connection to the %current_website% website.'), {current_website: current_website})"></p>
                </div>

                <h4 class="terms-title">{{ lang($t("Applicable Law")) }}</h4>
                <div class="terms-para">
                    <p>{{ lang($t("These Terms shall be governed by the laws of Hong Kong Special Administrative Region of China. Under irrevocable and unconditional situation, users agree that Hong Kong courts shall have exclusive jurisdiction.")) }}</p>
                </div>

                <h4 class="terms-title">{{ lang($t("Severability")) }}</h4>
                <div class="terms-para">
                    <p>{{ lang($t("All clauses in these Terms are severable. If for any reasons a clause is determined to be totally or partially invalid or unenforceable, the clause or a particular part of it will deem invalid, without affecting the enforceability of all remaining clauses or provisions.")) }}</p>
                </div>

                <h4 class="terms-title">{{ lang($t("Overall agreement")) }}</h4>
                <div class="terms-para">
                    <p v-html="lang($t('These terms and all documents mentioned represent complete understanding of the relationship between users and %current_website%, and supersede any previous statements or disclaimers. These terms may be amended from time to time.'), {current_website: current_website})"></p>
                </div>

                <h4 class="terms-title">{{ lang($t("Copyright")) }}</h4>
                <div class="terms-para">
                    <p v-html="lang($t('The contents of %current_website% are protected by intellectual property rights. All content editions (including collection, arrangement and compilation of contents) are exclusive properties of %current_website%, protected by Hong Kong and international copyright laws. Users have the right to download part of the contents for the purpose of purchasing goods or services online. Other purposes including copying, revision, distribution, transmission, showing or performance are strictly prohibited, unless allowed by law.'), {current_website: current_website})"></p>
                </div>

                <h4 class="terms-title">{{ lang($t("Privacy Policy")) }}</h4>
                <div class="terms-para">
                    <p v-html="lang($t('It is a priority for %current_website% to protect customers\' privacy.'), {current_website: current_website})"></p>
                    <p v-html="lang($t('%current_website% deploys independent and secure server to store personal data. This server is not connected to any website. %current_website% will not sell, rent or make any deals with customers\' personal details. %current_website% may report statistical figures of customers, sales, frequency of usage and other web data, but these figures would not include any recognizable personal data.'), {current_website: current_website})"></p>
                    <p v-html="lang($t('Although the above condition applies to general situations, %current_website% may share with its co-branded webpage its customer data, and %current_website% will not take responsibility or be reliable on how co-branded web pages handle those data.'), {current_website: current_website})"></p>
                </div>

            </div>
        </div>
    </div>

</template>

<script>

    import axios from 'axios';
    import {common} from '@mixins/common';
    import {storeMapper} from '@mixins/storeMapper';
    import api from '@js/api';
    import EventBus from '@common/eventBus';

    export default {
        name: "Terms",
        mixins:[common, storeMapper],
        /**路由相處理
         * 第一次進入本頁面時的動作。
         * @param to
         * @param from
         * @param next
         */
        beforeRouteEnter (to, from, next) {

            //Note in this route guard, access 'this' using vm (e.g. vm.fetchData() will trigger this.fetchData()
            next(vm=> {

                EventBus.$emit("showGlobalLoading");
                Promise.all(
                    [
                        api.getMainCate(),
                    ]
                    //With catch(() => undefined, we'll continue to the immediate "then block" even one/some of the api call(s) is/are rejected
                    //If something has to be processed when error returns, place the logic in catch block instead
                        .map(p => p.catch(() => undefined)))
                    .then(axios.spread((responseMainCate, responseDownloadData) => {

                        if (responseMainCate) {
                            vm.setWebSiteAndCate( responseMainCate.data, vm);
                        }

                        EventBus.$emit("hideGlobalLoading");

                    }))
                /*.catch(error=>{
                       //Handle errors here if something is expected to precess here
                   });
                   */


            });
        },
        computed: {
            current_website()
            {

                var url =   'http://'+window.location.host;

                if (location.protocol == 'https:')
                {
                    url = 'https://'+window.location.host;
                }

                return "<a class='txt-link' href='"+url+"'>"+url+"</a>";

            }
        }
    }
</script>

<style scoped>
    .title-head{margin-top: 0;}
    .terms-para{padding-bottom:2rem;}
    .terms-para:last-child{padding-bottom:0;}
    .terms-para * {line-height:170%;}
    .terms-para ul{padding-left:1rem;}
    .terms-para ul li{list-style:decimal;padding:0 0 1rem .5rem;}
    .terms-para ul li:last-child{padding-bottom:0;}
    .terms-para>p{padding-bottom:1rem;}
    .terms-para>p:last-child{padding-bottom:0;}
    h4.terms-title{font-size:1rem;padding-bottom:1rem;color:#608197;}

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/Terms.vue